"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mobileMenu = mobileMenu;
exports.filterMenu = filterMenu;
exports.aboutText = aboutText;
exports.modalManager = modalManager;
exports.cookieManager = cookieManager;
exports.objectMedia = objectMedia;
exports.aanbodSelectie = aanbodSelectie;
exports.relatedObjects = relatedObjects;
exports.buitengewoonGroen = buitengewoonGroen;
function mobileMenu() {
    return {
        menuOpen: false,
        toggleMenu() {
            this.menuOpen = !this.menuOpen;
        },
    };
}
function filterMenu() {
    return {
        modalOpen: false,
        toggleModal() {
            this.modalOpen = !this.modalOpen;
        },
        handleModal() {
            if (this.modalOpen)
                return;
            this.toggleModal();
        },
    };
}
function aboutText() {
    return {
        handler() {
            const container = document.getElementById("about-container");
            const element = document.getElementById("about-scroll");
            const scrollPosition = window.pageYOffset;
            const elementPosition = (container === null || container === void 0 ? void 0 : container.offsetTop) || 0;
            const elementHeight = (container === null || container === void 0 ? void 0 : container.offsetHeight) || 0;
            const scrollPercentage = (scrollPosition - elementPosition) / elementHeight;
            if (scrollPercentage < 0 || scrollPercentage > 1) {
                return;
            }
            element.scrollTo({
                left: scrollPercentage * element.scrollWidth,
            });
        },
        init() {
            window.addEventListener("scroll", this.handler);
        },
    };
}
function modalManager() {
    return {
        modalOpen: false,
        modalType: "",
        toggleModal() {
            this.modalOpen = !this.modalOpen;
        },
        handleModal(e) {
            if (this.modalOpen) {
                this.modalOpen = false;
            }
            this.modalType = e.detail.modalType || "";
            if (this.modalType !== "") {
                this.toggleModal();
            }
        },
    };
}
function cookieManager() {
    return {
        modalOpen: false,
        consent: {
            essential: true,
            ad_storage: false,
            analytics_storage: false,
        },
        showOptions: false,
        toggleModal() {
            this.modalOpen = !this.modalOpen;
        },
        handleModal() {
            if (this.modalOpen)
                return;
            this.showOptions = true;
            this.toggleModal();
        },
        allowAll() {
            this.consent = {
                essential: true,
                ad_storage: true,
                analytics_storage: true,
            };
            this.saveConsent();
        },
        storeConsent() {
            localStorage.setItem("cookie_consent", JSON.stringify(this.consent));
        },
        getConsent() {
            const consent = localStorage.getItem("cookie_consent");
            if (consent) {
                return JSON.parse(consent);
            }
            return null;
        },
        saveConsent() {
            this.storeConsent();
            this.toggleModal();
            this.emitConsent("update");
        },
        emitConsent(type) {
            window.gtag("consent", type, {
                ad_storage: this.consent.ad_storage ? "granted" : "denied",
                analytics_storage: this.consent.analytics_storage
                    ? "granted"
                    : "denied",
                ad_personalization: this.consent.ad_storage ? "granted" : "denied",
                ad_user_data: this.consent.ad_storage ? "granted" : "denied",
            });
        },
        init() {
            this.emitConsent("default");
            if (this.getConsent() !== null) {
                this.consent = this.getConsent();
                this.emitConsent("update");
            }
            else {
                this.toggleModal();
                // Set default consent
                this.consent = {
                    essential: true,
                    ad_storage: true,
                    analytics_storage: true,
                };
            }
        },
    };
}
function objectMedia() {
    return {
        tab: "photos",
        extended: false,
        slider: false,
        imageCount: 0,
        mapSlider: false,
        mapCount: 0,
        currentSlide: 0,
        openImage(index) {
            this.slider = true;
            this.currentSlide = index;
            this.scrollToImage();
        },
        openMap(index) {
            this.mapSlider = true;
            this.currentSlide = index;
        },
        nextImage() {
            if (this.slider) {
                if (this.currentSlide === this.imageCount) {
                    this.currentSlide = 0;
                    return;
                }
            }
            else {
                if (this.currentSlide === this.mapCount) {
                    this.currentSlide = 1;
                    return;
                }
            }
            this.currentSlide++;
            this.scrollToImage();
        },
        prevImage() {
            if (this.slider) {
                if (this.currentSlide === 0) {
                    this.currentSlide = this.imageCount;
                    return;
                }
            }
            else {
                if (this.currentSlide === 1) {
                    this.currentSlide = this.mapCount;
                    return;
                }
            }
            this.currentSlide--;
            this.scrollToImage();
        },
        scrollToImage() {
            const slider = this.slider
                ? this.$refs.imageCarousel
                : this.$refs.mapCarousel;
            this.$nextTick(() => {
                // Get the image element within the slider with the attribute selected
                const image = slider.querySelector("[selected]");
                // Scroll the image to the center of the slider
                slider.scrollTo({
                    left: image.offsetLeft - slider.offsetWidth / 2 + image.offsetWidth / 2,
                    behavior: "smooth",
                });
            });
        },
    };
}
const PRICE_OPTIONS = [
    "50000",
    "75000",
    "100000",
    "125000",
    "150000",
    "175000",
    "200000",
    "225000",
    "250000",
    "275000",
    "300000",
    "325000",
    "350000",
    "375000",
    "400000",
    "450000",
    "500000",
    "550000",
    "600000",
    "650000",
    "700000",
    "750000",
    "800000",
    "900000",
    "1000000",
    "1250000",
    "1500000",
    "2000000",
    "2500000",
    "3000000",
    "3500000",
    "4000000",
    "4500000",
    "5000000",
];
function aanbodSelectie() {
    return {
        filters: {
            type: "",
            place: "",
            from_price: "",
            to_price: "",
            surface: "",
            bedrooms: "",
            status: "",
        },
        queryOpen: false,
        searchQuery: "",
        objects: [],
        filterData: [
            {
                prop: "type",
                title: "Soort woning",
                options: [],
            },
            {
                prop: "place",
                title: "Plaats",
                options: [],
            },
            {
                prop: "from_price",
                title: "Vanaf prijs",
                options: PRICE_OPTIONS,
            },
            {
                prop: "to_price",
                title: "Tot prijs",
                options: PRICE_OPTIONS,
            },
            // {
            //   prop: 'surface',
            //   title: 'Oppervlakte',
            //   options: []
            // },
            {
                prop: "bedrooms",
                title: "Slaapkamers",
                options: [],
            },
            {
                prop: "status",
                title: "Status",
                options: [],
            },
        ],
        resultsWithOption(prop, option) {
            const cfilter = JSON.parse(JSON.stringify(this.filters));
            cfilter[prop] = option;
            return this.filteredObjects(cfilter).length;
        },
        handleSearch() {
            const query = this.searchQuery;
            return this.objects.filter(function (object) {
                var _a, _b;
                // Check if the query matches the title and/or place
                if (((_a = object.title) === null || _a === void 0 ? void 0 : _a.toLowerCase().includes(query.toLowerCase())) ||
                    ((_b = object.city) === null || _b === void 0 ? void 0 : _b.toLowerCase().includes(query.toLowerCase()))) {
                    return true;
                }
                return false;
            });
        },
        filteredObjects(filter = null) {
            if (this.searchQuery !== "" && this.searchQuery.length > 2) {
                return this.handleSearch();
            }
            if (filter === null) {
                filter = this.filters;
            }
            const filters = filter;
            return this.objects.filter(function (object) {
                var _a, _b, _c, _d, _e, _f, _g, _h;
                if (filters.type !== "" &&
                    ((_b = (_a = object.type) === null || _a === void 0 ? void 0 : _a.toLowerCase()) === null || _b === void 0 ? void 0 : _b.replaceAll("_", " ")) !== filters.type) {
                    return false;
                }
                if (filters.place !== "" &&
                    ((_c = object.city) === null || _c === void 0 ? void 0 : _c.toLowerCase()) !== ((_d = filters.place) === null || _d === void 0 ? void 0 : _d.toLowerCase())) {
                    return false;
                }
                if (filters.from_price !== "" &&
                    parseInt((_e = object.rawPrice) !== null && _e !== void 0 ? _e : 0) < parseInt(filters.from_price)) {
                    return false;
                }
                if (filters.to_price !== "" &&
                    parseInt((_f = object.rawPrice) !== null && _f !== void 0 ? _f : 0) > parseInt(filters.to_price)) {
                    return false;
                }
                if (filters.bedrooms !== "" &&
                    object.slaapkamers !== filters.bedrooms) {
                    return false;
                }
                if (filters.status !== "" &&
                    ((_g = object.status) === null || _g === void 0 ? void 0 : _g.toLowerCase().replaceAll("_", " ")) !==
                        ((_h = filters.status) === null || _h === void 0 ? void 0 : _h.toLowerCase())) {
                    return false;
                }
                return true;
            });
        },
        clear() {
            this.filters = {
                type: "",
                place: "",
                from_price: "",
                to_price: "",
                surface: "",
                bedrooms: "",
                status: "",
            };
            this.searchQuery = "";
        },
        setObjects(data) {
            this.objects = JSON.parse(data);
            // Make sure status 'VERKOCHT' and 'VERHUURD' are always at the end
            this.objects.sort((a, b) => {
                if (a.status === "VERKOCHT" || a.status === "VERHUURD") {
                    return 1;
                }
                if (b.status === "VERKOCHT" || b.status === "VERHUURD") {
                    return -1;
                }
                return 0;
            });
            // Set available places
            const places = [
                ...new Set(this.objects.map((object) => object.city.toLowerCase())),
            ];
            places.sort((a, b) => a.localeCompare(b)); // Sort places alphabetically
            this.filterData.find((filter) => filter.prop === "place").options =
                places;
            // Set the types
            const types = [
                ...new Set(this.objects
                    .filter(function (object) {
                    return object.type !== null;
                })
                    .map((object) => object.type.toLowerCase().replaceAll("_", " "))),
            ];
            types.sort((a, b) => a.localeCompare(b)); // Sort types alphabetically
            this.filterData.find((filter) => filter.prop === "type").options = types;
            // Set the bedrooms
            const bedrooms = [
                ...new Set(this.objects.map((object) => object.slaapkamers)),
            ];
            // Sort bedrooms by number
            bedrooms.sort((a, b) => {
                const aNum = parseInt(a);
                const bNum = parseInt(b);
                if (aNum > bNum)
                    return 1;
                if (aNum < bNum)
                    return -1;
                return 0;
            });
            this.filterData.find((filter) => filter.prop === "bedrooms").options =
                bedrooms;
            // Set the status
            const status = [
                ...new Set(this.objects.map((object) => object.status.toLowerCase().replaceAll("_", " "))),
            ];
            status.sort((a, b) => a.localeCompare(b)); // Sort status alphabetically
            this.filterData.find((filter) => filter.prop === "status").options =
                status;
        },
    };
}
function relatedObjects() {
    return {
        objects: [],
        setObjects(data) {
            this.objects = JSON.parse(data);
        },
        left() {
            this.$refs.aanbod.scroll({
                left: this.$refs.aanbod.scrollLeft - this.$refs.aanbod.clientWidth,
                behavior: "smooth",
            });
        },
        right() {
            this.$refs.aanbod.scroll({
                left: this.$refs.aanbod.scrollLeft + this.$refs.aanbod.clientWidth,
                behavior: "smooth",
            });
        },
    };
}
function buitengewoonGroen() {
    return {
        articles: [],
        page: 1,
        maxPage: 1,
        itemsPerPage: 12,
        category: "",
        articlesViewed() {
            const count = this.page * this.itemsPerPage;
            if (count > this.getArticlesInCategory().length) {
                return this.getArticlesInCategory().length;
            }
            return count;
        },
        getArticlesInCategory() {
            if (this.category === "") {
                return this.articles;
            }
            return this.articles.filter((article) => article.category === this.category);
        },
        filteredArticles() {
            return this.getArticlesInCategory().slice((this.page - 1) * this.itemsPerPage, this.page * this.itemsPerPage);
        },
        setArticles(data, itemsPerPage = null) {
            if (itemsPerPage !== null) {
                this.itemsPerPage = itemsPerPage;
            }
            this.articles = JSON.parse(data);
            this.maxPage = Math.ceil(this.articles.length / this.itemsPerPage);
        },
        nextPage() {
            if (this.page < this.maxPage) {
                this.page++;
            }
        },
        prevPage() {
            if (this.page > 1) {
                this.page--;
            }
        },
    };
}
